import { c as _c } from "react/compiler-runtime";
import { IcoEyeCrossed16, IcoFaceid24 } from '@onefootprint/icons';
import type { DocumentFaceComparison, DocumentFaceDetection } from '@onefootprint/request-types/dashboard';
import { Divider, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import CollapsibleSection from '../collapsible-section';
type FaceChecksProps = {
  detection?: DocumentFaceDetection;
  comparison?: DocumentFaceComparison;
};
const FaceChecks = t0 => {
  const $ = _c(29);
  const {
    detection,
    comparison
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.faceChecks"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    t: commonT
  } = useTranslation("common");
  let t2;
  if ($[1] !== commonT) {
    t2 = value => value ? commonT(_temp) : commonT(_temp2);
    $[1] = commonT;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const yesNo = t2;
  if (!detection && !comparison) {
    return null;
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp3);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex-shrink-0 text-tertiary"><IcoEyeCrossed16 /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Tooltip content={t3} side="left">{t4}</Tooltip>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const employeeOnly = t5;
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp4);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== detection || $[11] !== t || $[12] !== yesNo) {
    t7 = detection && <div className="flex flex-col gap-2 w-full"><p className="text-label-2 text-primary">{t(_temp5)}</p><Row label={t(_temp6)} value={yesNo(detection.faceDetected)} /><Row label={t(_temp7)} value={detection.faceCount} /><Row label={t(_temp8)} value={detection.rejected ? t(_temp9) : t(_temp10)} /></div>;
    $[10] = detection;
    $[11] = t;
    $[12] = yesNo;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== comparison || $[15] !== detection) {
    t8 = detection && comparison && <Divider />;
    $[14] = comparison;
    $[15] = detection;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== comparison || $[18] !== t || $[19] !== yesNo) {
    t9 = comparison && <div className="flex flex-col gap-2 w-full"><p className="text-label-2 text-primary">{t(_temp11)}</p><Row label={t(_temp12)} value={yesNo(comparison.performed)} /><Row label={t(_temp13)} value={typeof comparison.matches === "boolean" ? yesNo(comparison.matches) : t(_temp14)} /><Row label={t(_temp15)} value={comparison.similarityThreshold} /></div>;
    $[17] = comparison;
    $[18] = t;
    $[19] = yesNo;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="flex flex-col gap-3 w-full">{t7}{t8}{t9}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== employeeOnly || $[26] !== t10 || $[27] !== t6) {
    t11 = <CollapsibleSection icon={IcoFaceid24} title={t6} defaultOpen={true} badge={employeeOnly}>{t10}</CollapsibleSection>;
    $[25] = employeeOnly;
    $[26] = t10;
    $[27] = t6;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
};
const Row = t0 => {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <p className="text-body-2 text-tertiary">{label}</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <p className="text-body-2 text-primary text-right">{value}</p>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="w-full flex justify-between gap-6">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default FaceChecks;
function _temp($) {
  return $.yes;
}
function _temp2($_0) {
  return $_0.no;
}
function _temp3($_1) {
  return $_1.employeeOnly;
}
function _temp4($_2) {
  return $_2.title;
}
function _temp5($_3) {
  return $_3.detection;
}
function _temp6($_4) {
  return $_4.faceDetected;
}
function _temp7($_5) {
  return $_5.faceCount;
}
function _temp8($_6) {
  return $_6.outcome;
}
function _temp9($_7) {
  return $_7.fail;
}
function _temp10($_8) {
  return $_8.pass;
}
function _temp11($_9) {
  return $_9.comparison;
}
function _temp12($_10) {
  return $_10.performed;
}
function _temp13($_11) {
  return $_11.matches;
}
function _temp14($_12) {
  return $_12.unavailable;
}
function _temp15($_13) {
  return $_13.similarityThreshold;
}